<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-6">
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-section'].color"
                    @input="e => (fields['background-section'].color = e.target.value)"
                  />
                  <v-text-field v-model="fields['background-section'].color" label="Background Section" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @input="e => (fields.textColor = e.target.value)"
                  />
                  <v-text-field v-model="fields.textColor" label="Text Color" />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.padding.top" label="Top Padding" />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <div class="label-input">Container</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="12">
                <div class="d-flex align-center">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-content'].background"
                    @input="e => (fields['container-content'].background = e.target.value)"
                  />
                  <v-text-field v-model="fields['container-content'].background" label="Container Background" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="fields.container.enableContainer"
                  label="Enable container class"
                  hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="fields['container-content'].showStyle"
                  label="Show container style"
                  hide-details="true"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <label class="label-input">Title Content</label>
          <ckeditor :editor="editor" v-model="fields.titleMarkqueue" :config="editorConfig" />
        </div>

        <div>
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Rows</label>
            <v-btn small text color="primary" @click="handleAddRow">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Row</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(row, rowIndex) in fields.listRows.listItem" :key="rowIndex">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>Row {{ rowIndex + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveRow(rowIndex)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="d-flex justify-space-between align-center mb-2">
                  <label class="mb-0">Images</label>
                  <v-btn small text color="primary" @click="handleAddImage(rowIndex)">
                    <v-icon size="16">mdi-plus</v-icon>
                    <span>Add Image</span>
                  </v-btn>
                </div>
                <v-row>
                  <v-col v-for="(img, imgIndex) in row.images" :key="`${rowIndex}-${imgIndex}`" cols="12" md="6" lg="4">
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, rowIndex, imgIndex)"
                      :image="{ imageSrc: img.image }"
                      :height="`180`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemoveImage(rowIndex, imgIndex)"
                    />
                    <div class="d-flex justify-end mt-2">
                      <v-btn icon @click="handleRemoveImage(rowIndex, imgIndex)">
                        <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';

const defaultRow = () => ({
  images: [
    {
      image: '',
    },
  ],
});

export default {
  name: 'markqueue-rows',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Markqueue Rows Section',
        enableAnchor: false,
        textColor: '#000000',
        padding: {
          top: false,
          bottom: false,
        },
        'background-section': {
          color: '#ffffff',
        },
        'container-content': {
          showStyle: false,
          background: '#ffffff',
        },
        container: {
          enableContainer: true,
        },
        titleMarkqueue: '',
        listRows: {
          listItem: [defaultRow()],
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      padding: {
        ...this.fields.padding,
        ...(this.sectionEditor.sectionExtract.padding || {}),
      },
      'background-section': {
        ...this.fields['background-section'],
        ...(this.sectionEditor.sectionExtract['background-section'] || {}),
      },
      'container-content': {
        ...this.fields['container-content'],
        ...(this.sectionEditor.sectionExtract['container-content'] || {}),
      },
      container: {
        ...this.fields.container,
        ...(this.sectionEditor.sectionExtract.container || {}),
      },
      listRows: {
        listItem: this.normalizeRows(this.sectionEditor.sectionExtract.listRows?.listItem),
      },
    };
  },
  methods: {
    normalizeRows(rows) {
      if (!Array.isArray(rows) || rows.length === 0) return [defaultRow()];
      return rows.map(row => ({
        images:
          Array.isArray(row?.images) && row.images.length > 0
            ? row.images.map(img => ({ image: img?.image || '' }))
            : [{ image: '' }],
      }));
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionMarkqueueRows(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddRow() {
      this.fields.listRows.listItem.push(defaultRow());
    },
    handleRemoveRow(index) {
      this.fields.listRows.listItem.splice(index, 1);
      if (this.fields.listRows.listItem.length === 0) {
        this.fields.listRows.listItem.push(defaultRow());
      }
    },
    handleAddImage(rowIndex) {
      this.fields.listRows.listItem[rowIndex].images.push({ image: '' });
    },
    handleRemoveImage(rowIndex, imageIndex) {
      const row = this.fields.listRows.listItem[rowIndex];
      row.images.splice(imageIndex, 1);
      if (row.images.length === 0) row.images.push({ image: '' });
    },
    handleUploadImage(obj, rowIndex, imageIndex) {
      this.fields.listRows.listItem[rowIndex].images[imageIndex].image = obj?.imageSrc || '';
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0 0 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0 0 12px #0000000f;
}
</style>
